import React from 'react'
import LiveAction from '../../images/LiveAction.jpg'
import Footer from '../../components/Footer';
import Calendar from '../../components/Calendar';
import texture from '../../images/TextureBlue060C1D.png'

const Shows = () => {
    return (
        <div className='flex flex-col min-h-screen text-white Fixed mt-[-3.2rem]'>
            <div>
                <img src={LiveAction} alt="/" className='h-90 overflow:hidden' />
            </div>
            <Calendar />
            <div className='flex-1' style={{ backgroundImage: `url(${texture})`, backgroundRepeat: 'repeat' }} />
            <Footer />
        </div>
    )
}

export default Shows
